<template>
  <div class="topup-header">
    <div class="container">
      <div class="topup-header-main">
        <div class="links">
          <a href="http://www.njumobile.pl" rel="noreferrer" id="logoLink">
            <img src="../../assets/images/nju-logo.svg" alt="NjuMobile">
          </a>
          <a href="https://www.njumobile.pl/logowanie" rel="noreferrer" id="logInLink">zaloguj się</a>
        </div>
        <div class="banner zgody">
          <a href="https://www.njumobile.pl/oferta/nju-na-karte" target="_blank" rel="noreferrer" class="link" title="599 GB za zgodę na marketing">
            <img src="../../assets/images/banners/baner_zgody_750x200.png" alt="Przejdź">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupHeader'
}
</script>

<style src="../../assets/scss/header.scss" lang="scss"></style>
